import DeclineOrganizationTransferSuccessModal from './DeclineOrganizationTransferSuccessModal';

export default DeclineOrganizationTransferSuccessModal;
